var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('button', {
    staticClass: "back-button-wrapper pointer close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v(" × ")]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Prehraná hypotéka")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "prehranaForm",
      "disabled": _vm.disabled
    }
  }, [_vm._v(" Uložiť ")])]), _c('form', {
    staticClass: "mt-8",
    attrs: {
      "id": "prehranaForm"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.savePrehranaForm.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "required": "",
      "name": "moveToPrehrana",
      "label": "Prečo bol obchod prehratý?"
    },
    model: {
      value: _vm.reasonOfAction,
      callback: function callback($$v) {
        _vm.reasonOfAction = $$v;
      },
      expression: "reasonOfAction"
    }
  })], 1), _c('div', {
    staticClass: "methodology-hint"
  }, [_vm._v(" Použite pri obchode, ktorý klient realizoval inde alebo od riešenia definitívne odišiel. Archivácia klienta používa samostatný stav „Zrušená“. ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }